<div class="space-y-6">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'PURCHASES.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 mt-1">{{ 'PURCHASES.SUBTITLE' | translate }}</p>
    </div>
    <p-button icon="pi pi-plus" [label]="'PURCHASES.ADD' | translate" (onClick)="openCreate()" />
  </div>

  <!--
    Filters — bitta do'konda butun panel yashiriladi: ichida boshqa filtr yo'q,
    do'kon filtri esa "hammasi" bilan bir xil natija berardi.
  -->
  @if (storePick.visible()) {
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <p-select
        [options]="stores()"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'PURCHASES.STORE_FILTER' | translate"
        [showClear]="true"
        [(ngModel)]="filterStoreId"
        (onChange)="onFilterChange()"
        appendTo="body"
        class="w-full sm:w-72"
      />
    </div>
  }

  <!-- Table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="purchases()"
        [lazy]="true"
        (onLazyLoad)="load($event)"
        [totalRecords]="totalCount()"
        [paginator]="true"
        [rows]="pageSize"
        [rowsPerPageOptions]="[20, 50, 100]"
        [loading]="loading()"
        styleClass="p-datatable-gridlines"
        [tableStyle]="{ 'min-width': '52rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'PURCHASES.TABLE.NUMBER' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.DATE' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.SUPPLIER' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.STORE' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.ITEMS' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.TOTAL' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.REMAINING' | translate }}</th>
            <th>{{ 'PURCHASES.TABLE.STATUS' | translate }}</th>
            <th style="width: 5rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-p>
          <tr>
            <td>
              <code class="text-xs bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded">{{
                p.purchaseNumber
              }}</code>
            </td>
            <td class="text-sm text-gray-500">{{ p.purchaseDate | date: 'dd.MM.yyyy' }}</td>
            <td class="text-sm">
              @if (p.supplierName) {
                {{ p.supplierName }}
              } @else if (remaining(p) > 0) {
                <!--
                  Yetkazuvchisiz qarz — uni to'lab bo'lmaydi, chunki to'lov faqat
                  yetkazuvchi orqali yoziladi. Shuning uchun tuzatishga chaqiriladi.
                -->
                <button
                  type="button"
                  class="text-amber-700 dark:text-amber-400 underline underline-offset-2 hover:text-amber-800 dark:hover:text-amber-300"
                  (click)="openAssignSupplier(p)"
                >
                  {{ 'PURCHASES.ASSIGN.LINK' | translate }}
                </button>
              } @else {
                —
              }
            </td>
            <td class="text-sm text-gray-500">{{ p.storeName }}</td>
            <td class="text-center">{{ p.itemCount }}</td>
            <td class="font-semibold">{{ p.totalAmount | money: p.currency }}</td>
            <td>
              @if (remaining(p) > 0) {
                <span class="font-bold text-red-600 dark:text-red-400">{{
                  remaining(p) | money: p.currency
                }}</span>
              } @else {
                <span class="text-green-600 dark:text-green-400">—</span>
              }
            </td>
            <td>
              <p-tag
                [value]="'PURCHASES.STATUS.' + p.status | translate"
                [severity]="statusSeverity(p.status)"
              />
            </td>
            <td class="flex">
              <p-button
                icon="pi pi-eye"
                severity="secondary"
                [text]="true"
                size="small"
                (onClick)="openDetails(p.id)"
                [ariaLabel]="'PURCHASES.TABLE.VIEW' | translate"
              />
              <p-button
                icon="pi pi-trash"
                severity="danger"
                [text]="true"
                size="small"
                (onClick)="deletePurchase(p)"
              />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center py-12 text-gray-500 dark:text-gray-400">
              <div class="flex flex-col items-center gap-2">
                <i class="pi pi-inbox text-4xl text-gray-300"></i>
                <span>{{ 'PURCHASES.EMPTY' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- ── Create Dialog ─────────────────────────────────────────────────────── -->
<p-dialog
  [header]="'PURCHASES.ADD' | translate"
  [(visible)]="createVisible"
  [modal]="true"
  [style]="{ width: 'min(64rem, 97vw)' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-col gap-4 pt-2">
    <!--
      Pul/qarz kuzatilsinmi. O'CHIQ (sukut) — katta hajmli yuk kelganda tez va
      SODDA: faqat qoldiq oshadi, yetkazib beruvchi/to'lov/qarz umuman so'ralmaydi.
      YONIQ — hozirgi to'liq "Kirim" hujjati, kassa va kreditorlik hisobotiga yoziladi.
    -->
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 px-4 py-3"
    >
      <!--
        `min-w-0` SHART: flex bolasi sukutda o'z matni kabi keng bo'lishga
        harakat qiladi (flexbox'ning "min-content" muammosi) — usiz uzun
        gap matni tumblerni konteynerdan tashqariga chiqarib yuborardi.
      -->
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PURCHASES.FORM.TRACK_PAYMENT' | translate }}
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {{
            (trackPayment
              ? 'PURCHASES.FORM.TRACK_PAYMENT_ON_HINT'
              : 'PURCHASES.FORM.TRACK_PAYMENT_OFF_HINT'
            ) | translate
          }}
        </p>
      </div>
      <p-toggleswitch [(ngModel)]="trackPayment" class="shrink-0" />
    </div>

    <!-- Do'kon / Yetkazib beruvchi -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <!-- Do'kon bitta bo'lsa `openCreate()` da o'zi qo'yiladi. -->
      @if (storePick.visible()) {
        <div class="flex flex-col gap-1">
          <label for="pur-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'PURCHASES.FORM.STORE' | translate }} <span class="text-red-500">*</span>
          </label>
          <p-select
            inputId="pur-store"
            [options]="stores()"
            optionLabel="name"
            optionValue="id"
            [ngModel]="form().storeId"
            (ngModelChange)="patchForm({ storeId: $event })"
            appendTo="body"
            class="w-full"
          />
        </div>
      }
      <!-- Yetkazib beruvchi — faqat pul/qarz kuzatilganda ma'noli. -->
      @if (trackPayment) {
        <div class="flex flex-col gap-1">
          <label for="pur-supplier" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'PURCHASES.FORM.SUPPLIER' | translate }}
            <!-- Qarzga olinsa majburiy: yetkazuvchisiz qarzni keyin to'lab bo'lmaydi -->
            @if (form().paidAmount < total()) {
              <span class="text-red-600 dark:text-red-400">*</span>
            }
          </label>
          <p-select
            inputId="pur-supplier"
            [options]="suppliers()"
            optionLabel="name"
            optionValue="id"
            [ngModel]="form().supplierId"
            (ngModelChange)="patchForm({ supplierId: $event })"
            [showClear]="true"
            [placeholder]="'PURCHASES.FORM.SUPPLIER_PH' | translate"
            appendTo="body"
            class="w-full"
          />
          @if (form().paidAmount < total() && !form().supplierId) {
            <small class="text-xs text-red-600 dark:text-red-400">
              {{ 'PURCHASES.FORM.SUPPLIER_DEBT_HINT' | translate }}
            </small>
          }
        </div>
      }
    </div>

    <!--
      Hujjat valyutasi — yetkazib beruvchiga QAYSI pulda to'lanadi. Qatorlardagi
      narxlar va jami shu valyutada. Mahsulotning sotuv valyutasidan farq qilishi
      normal: `$` da olib so'mda sotish. Pulsiz kirimda hujjat valyutasi umuman
      yo'q — har mahsulot o'z valyutasida qoladi.
    -->
    @if (currencySvc.hasMultipleCurrencies() && trackPayment) {
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex flex-col gap-1">
          <label for="pur-currency" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'PURCHASES.FORM.CURRENCY' | translate }}
          </label>
          <p-select
            inputId="pur-currency"
            [options]="currencySvc.currencyOptions()"
            optionLabel="label"
            optionValue="value"
            [ngModel]="form().currency"
            (ngModelChange)="patchForm({ currency: $event })"
            appendTo="body"
            class="w-full"
          />
        </div>

        <div class="flex flex-col gap-1">
          <label for="pur-rate" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'PURCHASES.FORM.RATE' | translate }}
          </label>
          <input
            id="pur-rate"
            type="number"
            min="0"
            step="any"
            [ngModel]="form().exchangeRate"
            (ngModelChange)="patchForm({ exchangeRate: $event })"
            [placeholder]="'PURCHASES.FORM.RATE_PH' | translate"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-800"
          />
          <small class="text-xs text-gray-500 dark:text-gray-400">
            {{ 'PURCHASES.FORM.RATE_HINT' | translate }}
          </small>
        </div>
      </div>
    }

    <!-- Mahsulot qatorlari -->
    <!--
      Skanerlash hisoboti — model nimani bog'lay olgani OCHIQ aytiladi. Busiz
      foydalanuvchi 30 qatorli jadvalni ko'zi bilan tekshirishga majbur bo'lardi
      va bog'lanmagan qatorni sezmay saqlashga urinardi.
    -->
    @if (scanReport(); as sr) {
      <div class="flex flex-col gap-2">
        <div class="grid grid-cols-2 sm:grid-cols-5 gap-2">
          <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-2.5">
            <div class="text-xs text-gray-500">{{ 'PURCHASE_SCAN.REPORT.FOUND' | translate }}</div>
            <div class="text-lg font-bold">{{ sr.total }}</div>
          </div>
          <div
            class="rounded-lg border p-2.5"
            [class.border-green-200]="sr.matched > 0"
            [class.bg-green-50]="sr.matched > 0"
            [class.dark:bg-green-950]="sr.matched > 0"
            [class.border-gray-200]="sr.matched === 0"
          >
            <div class="text-xs text-gray-500">
              {{ 'PURCHASE_SCAN.REPORT.MATCHED' | translate }}
            </div>
            <div class="text-lg font-bold text-green-700 dark:text-green-400">{{ sr.matched }}</div>
          </div>
          <div
            class="rounded-lg border p-2.5"
            [class.border-amber-300]="sr.guess > 0"
            [class.bg-amber-50]="sr.guess > 0"
            [class.dark:bg-amber-950]="sr.guess > 0"
            [class.border-gray-200]="sr.guess === 0"
          >
            <div class="text-xs text-gray-500">{{ 'PURCHASE_SCAN.REPORT.GUESS' | translate }}</div>
            <div class="text-lg font-bold text-amber-700 dark:text-amber-400">{{ sr.guess }}</div>
          </div>
          <div
            class="rounded-lg border p-2.5"
            [class.border-red-200]="sr.unmapped > 0"
            [class.bg-red-50]="sr.unmapped > 0"
            [class.dark:bg-red-950]="sr.unmapped > 0"
            [class.border-gray-200]="sr.unmapped === 0"
          >
            <div class="text-xs text-gray-500">
              {{ 'PURCHASE_SCAN.REPORT.UNMAPPED' | translate }}
            </div>
            <div class="text-lg font-bold text-red-700 dark:text-red-400">{{ sr.unmapped }}</div>
          </div>
          <div
            class="rounded-lg border p-2.5"
            [class.border-amber-300]="sr.unclear > 0"
            [class.bg-amber-50]="sr.unclear > 0"
            [class.dark:bg-amber-950]="sr.unclear > 0"
            [class.border-gray-200]="sr.unclear === 0"
          >
            <div class="text-xs text-gray-500">
              {{ 'PURCHASE_SCAN.REPORT.UNCLEAR' | translate }}
            </div>
            <div class="text-lg font-bold text-amber-700 dark:text-amber-400">{{ sr.unclear }}</div>
          </div>
        </div>

        <!--
          Qo'lyozma daftar uchun eng muhim ogohlantirish. Bu qatorlar KUCHLI model
          bilan qayta o'qilgandan keyin ham noaniq qolgan (backend past ishonchda
          o'zi ikkinchi urinish qiladi) — ya'ni ularni faqat odam hal qila oladi.
        -->
        @if (sr.unclear) {
          <div
            class="rounded-lg border border-amber-200 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-950/20 p-3 text-sm text-amber-800 dark:text-amber-300"
          >
            {{ 'PURCHASE_SCAN.REPORT.UNCLEAR_HINT' | translate: { count: sr.unclear } }}
          </div>
        }
        @if (sr.guess) {
          <div
            class="rounded-lg border border-amber-200 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-950/20 p-3 text-sm text-amber-800 dark:text-amber-300"
          >
            {{ 'PURCHASE_SCAN.REPORT.GUESS_HINT' | translate: { count: sr.guess } }}
          </div>
        }
        @if (sr.unmapped) {
          <div
            class="rounded-lg border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-950/20 p-3 text-sm text-red-800 dark:text-red-300"
          >
            {{ 'PURCHASE_SCAN.REPORT.UNMAPPED_HINT' | translate: { count: sr.unmapped } }}
          </div>
        }
      </div>
    }

    <div class="rounded-lg border border-gray-200 dark:border-gray-800 overflow-x-auto">
      <table class="w-full text-sm min-w-[52rem]">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="text-left p-2 min-w-[14rem]">{{ 'PURCHASES.FORM.PRODUCT' | translate }}</th>
            <th class="text-left p-2 w-24">{{ 'PURCHASES.FORM.QTY' | translate }}</th>
            <th class="text-left p-2 w-36">{{ 'PURCHASES.FORM.COST' | translate }}</th>
            <th class="text-left p-2 w-36">{{ 'PURCHASES.FORM.NEW_SELL' | translate }}</th>
            <th class="text-right p-2 w-28">{{ 'PURCHASES.FORM.LINE_TOTAL' | translate }}</th>
            <th class="w-10"></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track $index) {
            <tr
              class="border-t border-gray-100 dark:border-gray-800 align-top"
              [class.bg-red-50]="row.scanMatch !== null && !row.productId"
              [class.dark:bg-red-950/20]="row.scanMatch !== null && !row.productId"
              [class.bg-amber-50]="isUnclear(row) && row.productId"
              [class.dark:bg-amber-950/20]="isUnclear(row) && row.productId"
            >
              <!-- Mahsulot + Variant (signal reaktiv: @if ishlaydi) -->
              <td class="p-2">
                <div class="flex gap-2">
                  <!--
                    `virtualScroll` majburiy: har bir qatorda mahsulotlarning TO'LIQ
                    ro'yxati bo'yicha tanlagich bor, usiz PrimeNG ochilganda hammasini
                    DOM'ga chizadi.
                  -->
                  <p-select
                    [options]="products()"
                    optionLabel="name"
                    optionValue="id"
                    [ngModel]="row.productId"
                    (ngModelChange)="
                      setRowField($index, 'productId', $event); onProductChange($index)
                    "
                    [filter]="true"
                    filterBy="name,barcode"
                    [loading]="productsLoading()"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="38"
                    [placeholder]="'PURCHASES.FORM.PRODUCT_PH' | translate"
                    appendTo="body"
                    class="flex-1"
                  />
                  <app-barcode-scanner
                    (barcodeDetected)="onProductBarcodeDetected($index, $event)"
                  />
                </div>

                <!--
                  Rasmdan o'qilgan nom mahsulot tanlangandan KEYIN ham qoladi —
                  bu dalil: noto'g'ri bog'lanishni faqat shu matnni tanlangan
                  mahsulot bilan solishtirib sezish mumkin.
                -->
                @if (row.scannedName) {
                  <div class="mt-1 px-1 text-xs">
                    <span class="text-gray-400">
                      {{ 'PURCHASE_SCAN.SCANNED_AS' | translate }}
                    </span>
                    <span class="text-gray-600 dark:text-gray-300">{{ row.scannedName }}</span>
                    <span [class]="matchClass(row.scanMatch)">
                      · {{ 'PURCHASE_SCAN.MATCH.' + row.scanMatch | translate }}
                    </span>
                    <!--
                      Model o'zi tan olgan noaniqlik. Ogohlantirish NOMGA emas,
                      butun qatorga tegishli: xira yozilgan satrda narx ham,
                      miqdor ham xato o'qilgan bo'lishi mumkin.
                    -->
                    @if (isUnclear(row)) {
                      <span class="text-amber-600 dark:text-amber-400 font-medium">
                        · {{ 'PURCHASE_SCAN.UNCLEAR_ROW' | translate }}
                      </span>
                    }
                  </div>
                }

                @if (row.hasVariants) {
                  <div class="mt-1.5">
                    @if (row.loadingVariants) {
                      <div class="flex items-center gap-1.5 text-xs text-gray-400 px-1">
                        <i class="pi pi-spin pi-spinner"></i>
                        {{ 'PURCHASES.FORM.LOADING_VARIANTS' | translate }}
                      </div>
                    } @else {
                      <p-select
                        [options]="row.variantOptions"
                        optionLabel="label"
                        optionValue="id"
                        [ngModel]="row.productVariantId"
                        (ngModelChange)="
                          setRowField($index, 'productVariantId', $event); onVariantChange($index)
                        "
                        [placeholder]="'PURCHASES.FORM.VARIANT_PH' | translate"
                        appendTo="body"
                        class="w-full"
                      />
                    }
                  </div>
                }
              </td>

              <!-- Miqdor -->
              <td class="p-2 w-16">
                <p-inputnumber
                  [ngModel]="row.quantity"
                  (ngModelChange)="setRowField($index, 'quantity', $event)"
                  [min]="0"
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="6"
                  class="w-full"
                />
              </td>

              <!-- Kelish narxi -->
              <td class="p-2">
                <!--
                  Aniqlik kirim valyutasidan olinadi. Berilmasa PrimeNG 2 xonaga
                  yaxlitlaydi va `4.4234 $` lik tannarx `4.42 $` bo'lib ketardi.
                  Pulsiz kirimda hujjat valyutasi yo'q — mahsulotning O'Z kelish
                  valyutasi ishlatiladi.
                -->
                <p-inputnumber
                  [ngModel]="row.purchasePrice"
                  (ngModelChange)="setRowField($index, 'purchasePrice', $event)"
                  [min]="0"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="
                    currencySvc.priceInputDecimals(
                      trackPayment ? form().currency : row.currentPurchaseCurrency
                    )
                  "
                  [useGrouping]="true"
                  mode="decimal"
                  class="w-full"
                />
              </td>

              <!-- Yangi sotuv narxi -->
              <td class="p-2">
                <!-- Sotuv narxi SOTUV valyutasida — kirim valyutasidan mustaqil. -->
                <p-inputnumber
                  [ngModel]="row.newSellPrice"
                  (ngModelChange)="setRowField($index, 'newSellPrice', $event)"
                  [min]="0"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="
                    currencySvc.priceInputDecimals(row.newSellCurrency ?? row.currentSellCurrency)
                  "
                  [useGrouping]="true"
                  mode="decimal"
                  [placeholder]="sellPricePlaceholder(row)"
                  class="w-full"
                />
                <!--
                  Sotuv valyutasi kirim valyutasidan MUSTAQIL: `$` da olib so'mda
                  sotish normal. Lekin egasi shu paytda uni almashtirishi ham
                  mumkin — narx baribir kiritilyapti. Pulsiz kirimda bu almashtirish
                  yo'q (`AddStockBatchCommand` buni bilmaydi) — sotuv narxini
                  o'zgartirish uchun valyuta bir xil qolishi kerak.
                -->
                @if (currencySvc.hasMultipleCurrencies() && row.productId && trackPayment) {
                  <p-select
                    [options]="currencySvc.currencyOptions()"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="row.newSellCurrency"
                    (ngModelChange)="setRowField($index, 'newSellCurrency', $event)"
                    [ariaLabel]="'PURCHASES.FORM.SELL_CURRENCY' | translate"
                    appendTo="body"
                    size="small"
                    class="w-full mt-1"
                  />
                  @if (row.newSellCurrency !== row.currentSellCurrency) {
                    <div class="text-xs text-amber-600 dark:text-amber-500 mt-0.5 px-1">
                      {{ 'PURCHASES.FORM.SELL_CURRENCY_CHANGED' | translate }}
                    </div>
                  }
                }
                @if (row.currentSellPrice !== null) {
                  <div class="text-xs text-gray-400 mt-0.5 px-1">
                    {{ 'PURCHASES.FORM.CURRENT_SELL' | translate }}:
                    {{ row.currentSellPrice | money: row.currentSellCurrency }}
                  </div>
                }
              </td>

              <!-- Qator jami — pulsiz kirimda hujjat valyutasi yo'q, shuning
                   uchun HAR QATOR o'z (mahsulot) valyutasida ko'rsatiladi. -->
              <td class="p-2 text-right font-medium pt-3">
                {{
                  rowTotal(row)
                    | money: (trackPayment ? form().currency : row.currentPurchaseCurrency)
                }}
              </td>

              <!-- O'chirish -->
              <td class="p-2 text-center pt-2">
                <button class="text-red-500 hover:text-red-700" (click)="removeRow($index)">
                  <i class="pi pi-times"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <!--
        `[text]="true"` avval ikkalasida ham bor edi — natijada ular oddiy YOZUV
        bo'lib ko'rinardi, tugma emas (foydalanuvchi shikoyati). "Qator qo'shish"
        endi chegarali quti (`outlined`, ikkinchi darajali). "AI bilan to'ldirish"
        esa maxsus (Tailwind) tugma — bo'limning bosh imkoniyati sifatida
        yaltiroq gradient bilan ajratilgan, PrimeNG standart ranglaridan birontasi
        buni bermaydi.
      -->
      <div
        class="p-3 border-t border-gray-100 dark:border-gray-800 flex flex-wrap items-center gap-2"
      >
        <p-button
          icon="pi pi-plus"
          [label]="'PURCHASES.FORM.ADD_ROW' | translate"
          severity="secondary"
          [outlined]="true"
          size="small"
          (onClick)="addRow()"
        />

        <!--
          Kamera va galereya — IKKITA alohida input, lekin BITTA tugma orqali.
          Bitta umumiy inputga `capture` atributi qo'yilsa, ba'zi qurilmalarda u
          galereyani butunlay to'sib faqat kamerani ochadi; qo'yilmasa boshqa
          qurilmalarda kamera variantini umuman ko'rsatmaydi. Shuning uchun ikkala
          input alohida qoladi, lekin foydalanuvchiga BITTA tugma va kichik
          tanlash menyusi ko'rinadi — `scanMenu.toggle()`.
        -->
        <input
          #cameraInput
          type="file"
          accept="image/*"
          capture="environment"
          class="hidden"
          (change)="onScanFile($event)"
        />
        <input
          #galleryInput
          type="file"
          accept="image/*"
          class="hidden"
          (change)="onScanFile($event)"
        />
        <p-menu #scanMenu [model]="scanMenuItems" [popup]="true" appendTo="body" />

        <button
          type="button"
          class="group relative flex items-center gap-1.5 overflow-hidden rounded-lg bg-gradient-to-r from-lime-400 via-green-400 to-emerald-500 px-3 py-1.5 text-sm font-semibold text-white shadow-[0_2px_10px_rgba(74,222,128,0.5)] transition-transform hover:scale-[1.03] hover:shadow-[0_4px_16px_rgba(74,222,128,0.7)] active:scale-100 disabled:opacity-60 disabled:hover:scale-100"
          [disabled]="scanning()"
          (click)="openScanMenu($event, scanMenu, cameraInput, galleryInput)"
        >
          <!-- Yaltiroq "shine" chizig'i — hoverda chapdan o'ngga o'tadi. -->
          <span
            class="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/50 to-transparent transition-transform duration-700 group-hover:translate-x-full"
          ></span>
          @if (scanning()) {
            <i class="pi pi-spin pi-spinner relative"></i>
          } @else {
            <i class="pi pi-sparkles relative"></i>
          }
          <span class="relative">{{ 'PURCHASE_SCAN.BUTTON' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- To'lov — faqat pul/qarz kuzatilganda. -->
    @if (trackPayment) {
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 items-end">
        <div class="flex flex-col gap-1">
          <label for="pur-method" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'PURCHASES.FORM.METHOD' | translate }}
            <span class="text-red-600 dark:text-red-400">*</span>
          </label>
          <p-select
            inputId="pur-method"
            [options]="paymentMethods"
            optionValue="value"
            [ngModel]="form().paymentMethod"
            (ngModelChange)="patchForm({ paymentMethod: $event })"
            [placeholder]="'PURCHASES.FORM.METHOD_PH' | translate"
            appendTo="body"
            class="w-full"
          >
            <ng-template let-opt pTemplate="item">{{ opt.label | translate }}</ng-template>
            <ng-template let-opt pTemplate="selectedItem">{{ opt.label | translate }}</ng-template>
          </p-select>
          <!--
            Izoh usulga qarab o'zgaradi: `External` da pul biznes hisoblaridan
            chiqmaydi, shuning uchun "qoldiqdan yechiladi" degan matn yolg'on bo'lardi.
          -->
          <span class="text-xs text-gray-400 dark:text-gray-500">
            {{
              (form().paymentMethod === 'External'
                ? 'PURCHASES.FORM.METHOD_HINT_EXTERNAL'
                : 'PURCHASES.FORM.METHOD_HINT'
              ) | translate
            }}
          </span>
        </div>
        <div class="flex flex-col gap-1">
          <label for="pur-due" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'PURCHASES.FORM.DUE_DATE' | translate
          }}</label>
          <p-datepicker
            inputId="pur-due"
            [ngModel]="form().dueDate"
            (ngModelChange)="patchForm({ dueDate: $event })"
            dateFormat="dd.mm.yy"
            [showClear]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>
        <div class="flex flex-col gap-1">
          <label for="pur-paid" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'PURCHASES.FORM.PAID' | translate
          }}</label>
          <div class="flex gap-2">
            <!--
              Bu SUMMA (yetkazuvchiga berilgan pul), dona narxi emas — shuning uchun
              aniqlik valyutaning o'z kasr xonasi bo'yicha (UZS: 0, USD: 2).
            -->
            <p-inputnumber
              inputId="pur-paid"
              [ngModel]="form().paidAmount"
              (ngModelChange)="patchForm({ paidAmount: $event })"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="currencySvc.info(form().currency).decimals"
              [useGrouping]="true"
              mode="decimal"
              class="w-full"
            />
            <p-button
              icon="pi pi-check"
              [label]="'PURCHASES.FORM.PAID_FULL' | translate"
              severity="secondary"
              [outlined]="true"
              size="small"
              (onClick)="markPaidFull()"
            />
          </div>
        </div>
      </div>
    }

    <div class="flex flex-col gap-1">
      <label for="pur-notes" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'PURCHASES.FORM.NOTES' | translate
      }}</label>
      <input
        id="pur-notes"
        type="text"
        pInputText
        [ngModel]="form().notes"
        (ngModelChange)="patchForm({ notes: $event })"
        class="w-full"
      />
    </div>

    <!--
      Jami — faqat pul kuzatilganda ko'rsatiladi: hujjat BITTA valyutada. Pulsiz
      kirimda qatorlar TURLI valyutada bo'lishi mumkin (har biri o'z narxida
      ko'rsatilgan), ularni bitta summaga qo'shish (I11) noto'g'ri bo'lardi.
    -->
    @if (trackPayment) {
      <div class="rounded-lg bg-gray-50 dark:bg-gray-800 p-3 flex flex-col gap-1 text-sm">
        <div class="flex justify-between">
          <span class="text-gray-500">{{ 'PURCHASES.FORM.TOTAL' | translate }}</span>
          <span class="font-bold">{{ total() | money: form().currency }}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-gray-500">{{ 'PURCHASES.FORM.DEBT' | translate }}</span>
          <span class="font-bold text-red-600 dark:text-red-400">
            {{ total() - (form().paidAmount || 0) | money: form().currency }}
          </span>
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'COMMON.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="createVisible = false"
      [disabled]="saving"
    />
    <p-button
      [label]="'PURCHASES.FORM.SAVE' | translate"
      icon="pi pi-check"
      (onClick)="save()"
      [loading]="saving"
    />
  </ng-template>
</p-dialog>

<!-- Kirim tafsilotlari -->
<p-dialog
  header="Kirim tafsilotlari"
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width: 'min(52rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDetails()"
>
  @if (detailLoading) {
    <div class="flex items-center justify-center gap-2 py-12 text-gray-400">
      <i class="pi pi-spin pi-spinner text-2xl"></i>
      {{ 'COMMON.LOADING' | translate }}
    </div>
  } @else if (selectedPurchase(); as purchase) {
    <div class="flex flex-col gap-5 pt-2">
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm">
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'PURCHASES.DETAIL.NUMBER' | translate }}
          </p>
          <code class="bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded text-xs">{{
            purchase.purchaseNumber
          }}</code>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'PURCHASES.DETAIL.DATE' | translate }}
          </p>
          <p class="font-medium">{{ purchase.purchaseDate | date: 'dd.MM.yyyy HH:mm' }}</p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'PURCHASES.DETAIL.STORE' | translate }}
          </p>
          <p class="font-medium">{{ purchase.storeName }}</p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'PURCHASES.DETAIL.SUPPLIER' | translate }}
          </p>
          <p class="font-medium">{{ purchase.supplierName || '—' }}</p>
        </div>
        <div>
          <p class="text-gray-400 text-xs uppercase tracking-wider mb-0.5">
            {{ 'PURCHASES.DETAIL.TOTAL' | translate }}
          </p>
          <p class="font-bold">{{ purchase.totalAmount | money: purchase.currency }}</p>
        </div>
      </div>

      <div class="rounded-lg border border-gray-200 dark:border-gray-700 overflow-x-auto">
        <table class="w-full text-sm min-w-[36rem]">
          <thead class="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th class="text-left px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">
                {{ 'PURCHASES.DETAIL.PRODUCT' | translate }}
              </th>
              <th class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">
                {{ 'PURCHASES.DETAIL.QTY' | translate }}
              </th>
              <th class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">
                {{ 'PURCHASES.DETAIL.COST' | translate }}
              </th>
              <th class="text-right px-4 py-2.5 text-xs font-semibold text-gray-500 uppercase">
                {{ 'PURCHASES.DETAIL.LINE_TOTAL' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (item of purchase.items; track item.id) {
              <tr>
                <td class="px-4 py-2.5 font-medium text-gray-900 dark:text-gray-100">
                  {{ item.productName }}
                  @if (item.variantLabel) {
                    <span class="block mt-0.5 text-xs text-indigo-600 dark:text-indigo-400">{{
                      item.variantLabel
                    }}</span>
                  }
                </td>
                <td class="px-4 py-2.5 text-right tabular-nums">
                  {{ item.quantity | number: '1.0-6' }}
                </td>
                <td class="px-4 py-2.5 text-right tabular-nums">
                  {{ item.purchasePrice | money: item.currency }}
                </td>
                <td class="px-4 py-2.5 text-right font-semibold tabular-nums">
                  {{ item.lineTotal | money: item.currency }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <p-button label="Yopish" severity="secondary" [outlined]="true" (onClick)="closeDetails()" />
  </ng-template>
</p-dialog>

<!-- Yetkazuvchisiz qolgan eski hujjatni tuzatish -->
<p-dialog
  [(visible)]="assignVisible"
  [modal]="true"
  [style]="{ width: '28rem' }"
  [header]="'PURCHASES.ASSIGN.TITLE' | translate"
>
  @if (assignTarget(); as t) {
    <div class="flex flex-col gap-4">
      <p class="text-sm text-gray-600 dark:text-gray-400">
        {{ 'PURCHASES.ASSIGN.HINT' | translate }}
      </p>
      <div class="rounded-lg bg-gray-50 dark:bg-gray-800 p-3 text-sm flex justify-between">
        <code>{{ t.purchaseNumber }}</code>
        <span class="font-bold text-red-600 dark:text-red-400">
          {{ remaining(t) | money: t.currency }}
        </span>
      </div>
      <div class="flex flex-col gap-1">
        <label for="assign-supplier" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PURCHASES.FORM.SUPPLIER' | translate }}
        </label>
        <p-select
          inputId="assign-supplier"
          [options]="suppliers()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="assignSupplierId"
          [placeholder]="'PURCHASES.FORM.SUPPLIER_PH' | translate"
          appendTo="body"
          class="w-full"
        />
        @if (!suppliers().length) {
          <small class="text-xs text-amber-700 dark:text-amber-400">
            {{ 'PURCHASES.ASSIGN.NO_SUPPLIERS' | translate }}
          </small>
        }
      </div>
    </div>
  }
  <ng-template pTemplate="footer">
    <p-button
      [label]="'COMMON.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="assignVisible = false"
    />
    <p-button
      [label]="'PURCHASES.ASSIGN.SAVE' | translate"
      [loading]="assignSaving"
      [disabled]="!assignSupplierId"
      (onClick)="saveAssignSupplier()"
    />
  </ng-template>
</p-dialog>

<p-confirmdialog />
